import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/list-sc"
    image="/static/img/Card-ViewOpenTickets.png"
    imageAlt="Person looking at list in a notebook"
    description="View Open Tickets"
    loggedOutDescription="Log in to View Open Tickets"
  >
    Track support tickets in progress
  </FeatureCard>
);
